import React from 'react';
import './home.css'
import Header from '../components/layout/header';
import Sec1 from '../sections/sec1';
import Sec2 from '../sections/sec2';
import Sec3 from '../sections/sec3';
import Sec4 from '../sections/sec4';
import Footerr from '../components/layout/footer';
const Home = () => {
    return ( 
        <>
            <Header homeActive="active" propertiesActive="unactive" contactActive="unactive" />
            <main>
                <Sec1 />
                <Sec2 />
                <Sec3 />
                <Sec4 />
            </main>
            <Footerr />
        </>
     );
}
 
export default Home;